<template>
  <div id="card-details">
    <div id="info" class="margem-title-principal">
        <p class="text-left"><i class="fas fa-clipboard-list"></i><span class=" ml-1">RESUMO</span></p>
    </div>

    <div v-if="localDetails.empreendimentoNovaUnidade" class="title-principal">
        <i class="fas fa-building"></i>{{ localDetails.empreendimentoNovaUnidade.nomeEmpreendimento }}
    </div>

    <div class="container-satus-garantia">
        <div class="status">
            <p class="p_Name margin"> Status </p>
            <div class="status-style" :style="{'background-color': getcolor}">{{getStatus}}</div>
        </div>
        <div class="garantia">
            <p class="p_Name"> Garantia? </p>
            <div class="check-container">
                <inputnewboll teste="200px" id="check" type="checkbox" :disable="true" :switchbutton="true" :switchguarantee="localDetails.garantia" :value="localDetails.garantia"></inputnewboll>
            </div>
        </div>
    </div>

        <div class="margem-resu-info">
          <div class="label-details-title">Morador</div>
          <div class="label-details">{{localDetails.nomeMorador}}</div>
        </div>
        <div class="margem-resu-info" v-if="localDetails.dataAcaoFormatada != null ">
            <div class="label-details-title">Data do Chamado</div>
            <div class="label-details">{{localDetails.dataAcaoFormatada}}</div>
        </div>

        <div class="margem-resu-info">
            <div class="label-details-title">Causa Raiz</div>
            <div class="label-details">{{localDetails.getNameRaiz}}</div>
        </div>
        <div class="margem-resu-info">
            <div class="label-details-title">Técnico Responsável</div>
            <div class="label-details">
                {{ localDetails.tecnico && localDetails.tecnico.nome ? localDetails.tecnico.nome : 'Sem Técnico Cadastrado' }}
            </div>
        </div>
        <div class="margem-resu-info">
            <div class="label-details-title">Engenheiro Responsável</div>
            <div class="label-details">
                {{ localDetails.engenheiro && localDetails.engenheiro.nome ? localDetails.engenheiro.nome : 'Sem Técnico Cadastrado' }}
            </div>
        </div>
</div>
</template>

<script>
import Painelocorrence from './painelocorrence'
export default Painelocorrence
</script>

<style scoped>
.margin{
    margin-bottom: 0.3rem !important;
}

#card-details{
    width: 100%;
    border: 1px solid rgb(202, 202, 202);
    background-color: white;
    border-radius: 5px;
    padding-bottom: 25px;
    height: 100%;
}

#nameTower{
    color: rgb(90, 90, 90);
    font-size: 20px;
    font-weight: bold;
    line-height: 30px;
}
#info{
    height: 50px;
    width: 100%;
    font-size: 22px;
    background-color: #008148;
    padding-top: 15px;
    color: white;
}

.text-left{
    font-size: 18px;
}
.label-details{
    font-size: 14px;
    color: #2A2A2A;
    margin-bottom: 0px;
    line-break: anywhere;
}
.result-details{
    font-size: 16px;
    font-weight: bold;
}

#statuspanel{
    display: flex;
    width: 50%;
    height: 30px;
    color: white;
    justify-content: center;
    padding-left: 10%;
    padding-right: 10%;
    border-radius: 25px;
    align-items: center;
    background: #0077FF;
}

.container-satus-garantia {
    padding: 0.7rem;
    display: grid;
    gap: 1rem;
    grid-template-columns: 1fr;
    grid-template-rows: 1fr 1fr;
    grid-auto-columns: 1fr;
    grid-auto-flow: row;
    grid-template-areas:
        "status"
        "garantia";
    row-gap: 1rem;
}

.status {
    width: 100%;
 }

.garantia {
    display: flex;
    gap: 0.3rem;
    flex-direction: column;
}

.status-style{
    background-color: #008148;
    border-radius: 15px;
    height: 2rem;
    color: white;
    font-size: 13px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 2rem;
}

.checkcolor{
    accent-color: #008148;
    width: 1.2rem;
}
.simCheck{
    display: flex;
    align-items: center;
    text-align: left;
    color: black;
    padding-left: 0.5rem;
    font: normal normal normal 15px/19px Segoe UI;
}

.check-container{
    display: flex;
    height: 25px;
    cursor: default;
}
.p_Name{
    font: normal normal normal 16px/21px Segoe UI;
    color: #666666;
    text-align: left;
    margin: 0;
    font-weight: bold;
}
.label-details-title{
  font-size: 13px;
  color: #666666;
  font-weight: bold;
  margin-bottom: 0px;
}
.label-details{
  font-size: 15px;
  color:#2A2A2A;
}
.margem-resu-info{
    padding: 0.7rem;
    display: flex;
    gap: 0.3rem;
    flex-direction: column;
    font: 16px 'Segoe UI';
}
.title-principal{
  font-size: 17px;
  color: #666666;
  margin: 1rem;
  margin-bottom: 0px;
  display: flex;
    gap: 0.3rem;
    font-family: 'Segoe UI';
}
.margem-title-principal{
    padding:0.7rem;
}

@media (min-width:1366px) {
    .container-satus-garantia{
        display: flex;
        justify-content: space-between;
        /* grid-template-columns: 1fr 1fr;
        grid-template-rows: 1fr;
        grid-template-areas:
        "status garantia"; */
    }

    .garantia {
        display: flex;
        flex-direction: column;
    }

    .status-style{
        margin-right: 0;
    }
}

</style>



// WEBPACK FOOTER //
// src/views/private/realestate/ocurrence/components/painelocorrence/painelocorrence.vue